<template>
    <b-button
        v-if="canUpdate"
        variant="success"
        :disabled="!can || buttonState === 'disabled'"
        :title="buttonTitle"
        @click="generateDeadlines"
    >
        Générer les échéances
    </b-button>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'GenerateDeadlines',

    mixins: [DataUpdater],

    props: {
        client: {
            type: Number,
            required: true,
        },
        can: {
            type: Boolean,
            required: true,
        },
        buttonState: {
            type: String,
            required: true,
        },
    },

    methods: {
        async generateDeadlines() {
            try {
                await axios.get(
                    `/clients/${this.client}/clientDeadlines/${this.year}/generation`
                )
                this.updateData()
            } catch (error) {
                console.log(error)
            }
        },
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year,
            allRolesAssigned: (state) => state.browsing.allRolesAssigned,
            needsUpdate: (state) => state.browsing.needsUpdate,
        }),

        buttonTitle() {
            return this.can
                ? 'Cliquer pour générer les échéances'
                : 'Seuls les rôles EXP, MAN et SUP peuvent générer les échéances'
        },

        canUpdate() {
            // return this.needsUpdate && this.allRolesAssigned
            return this.needsUpdate
        },
    },
}
</script>

<style scoped></style>
